<div class="card">
  <app-header titulo="Transferências de insumos" descricao="Solicitações de transferencias de insumos."></app-header>

  <p-table [value]="transferencias" dataKey="idTransf" [(selection)]="transferenciasSelecionadas" [loading]="loading" #dt
           [lazy]="true" (onLazyLoad)="onLazyLoad($event)"
           [globalFilterFields]="['instancia','idTransf','numeroOs','codigoMaterialErp','codigoDepositoOrigemErp','codigoDepositoDestinoErp','numeroDocumentoErp','moduloOrigem']"
           styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines  text-sm"
           [rowsPerPageOptions]="[20, 50, 100, 500, 1000]" [paginator]="true" [rows]="20" [showCurrentPageReport]="true"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Transferências selecionadas {{transferenciasSelecionadas.length}} | Mostrando de {first} até {last} de {totalRecords} registros"
           (onPage)="onPageChange($event)" (onFilter)="onFilter($event)" (selectionChange)="onSelectionChange()">
    <ng-template pTemplate="caption">
      <div class="flex text-sm">
        <app-empresa-dropdown [(selecionadas)]="instanciaSelecionada" />

        <div class="flex justify-content-center">
          <p-calendar
            [(ngModel)]="rangeDates"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            [readonlyInput]="true"
            (onClose)="recarregar()"
          />
        </div>
        <div class="flex justify-content-center text-sm">
          <p-splitButton
            class="ml-3 text-sm"
            label="Exportar Todos"
            icon="pi pi-file-excel"
            (onClick)="exportarTodos()"
            [model]="itensExportacao"
            styleClass="text-sm"
          />
        </div>

        <button *ngIf="tentativasHabilitado" pButton pRipple icon="pi pi-send" class="ml-3 text-sm" (click)="reenviar()" label="Reenviar"></button>

        <span class="p-input-icon-left ml-auto">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($any($event.target)?.value, 'contains')"
                     placeholder="Pesquisar"/>
          </span>
        <button class="ml-3" pButton pRipple icon="pi pi-refresh" (click)="recarregar()" [loading]="loading"></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr class="text-sm">
        <th style="width: 4rem">
          <p-checkbox [(ngModel)]="selecionados" [binary]="true" (onChange)="selecionarRegistros($event)">
            <ng-template pTemplate="icon">
                    <span>
                     <i *ngIf="iconeCheckbox === 'Nenhum'"
                        class="pi pi-square"></i>
                      <i *ngIf="iconeCheckbox === 'Parcial'"
                         class="pi pi-minus"
                         style="color: var(--secondary-color);"></i>
                      <i *ngIf="iconeCheckbox === 'Todos'"
                         class="pi pi-check"
                         style="color: var(--secondary-color);"></i>
                    </span>
            </ng-template>
          </p-checkbox>
          <span><a style="text-decoration: underline; cursor: pointer" (click)="selecionarTodos()"
                   *ngIf="transferenciasSelecionadas.length >= 1 && transferenciasSelecionadas.length < transferencias.length">Tudo?</a></span>
        </th>
        <th>ID</th>
        <th>Instância</th>
        <th>Nº OS</th>
        <th>Dt Lançamento</th>
        <th>Cód. Material ERP</th>
        <th>Qtd Solicitada</th>
        <th>Qtd Transferida</th>
        <th>Depósito Origem</th>
        <th>Depósito Destino</th>
        <th class="nowrap">Dt Receb. PIMS</th>
        <th>Status</th>
        <th>Nº Documento ERP</th>
        <th>Dt Integ ERP</th>
        <th pSortableColumn="fgStatusInteg">
          Status Integracão
          <p-sortIcon field="fgStatusInteg"/>
          <p-columnFilter field="fgStatusInteg" matchMode="in" display="menu" [showApplyButton]="false"
                          [showClearButton]="false" [showMatchModes]="false" [showOperator]="false"
                          [showAddButton]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-multiSelect [ngModel]="value" selectedItemsLabel="Vários selecionados" [options]="status"
                             placeholder="Todos" [filter]="true" optionValue="value" (onChange)="filter($event.value)"
                             optionLabel="name">
                <ng-template let-option pTemplate="item">
                  <div class="inline-block vertical-align-middle">
                    <span class="ml-1 mt-1">{{ option.name }}</span>
                  </div>
                </ng-template>
              </p-multiSelect>
            </ng-template>
            <ng-template pTemplate="clearfiltericon">
            </ng-template>
          </p-columnFilter>
        </th>
        <th class="nowrap">Mensagem</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-transferencia>
      <tr>
        <td>
          <p-tableCheckbox [value]="transferencia"/>
        </td>
        <td>{{ transferencia.idTransf }}</td>
        <td>{{ transferencia.instancia }}</td>
        <td>{{ transferencia.numeroOs }}</td>
        <td>{{ transferencia.dataLancamento | date: 'dd/MM/yyyy' }}</td>
        <td>{{ transferencia.codigoMaterialErp }}</td>
        <td>{{ transferencia.quantidadeSolicitada | number:'1.1-5' }}</td>
        <td>{{ transferencia.quantidadeTransferida | number:'1.1-5' }}</td>
        <td>{{ transferencia.codigoDepositoOrigemErp }}</td>
        <td>{{ transferencia.codigoDepositoDestinoErp }}</td>
        <td class="nowrap">{{ transferencia.dataRecebimentoPims | date: 'dd/MM/yyyy HH:mm' }}</td>        
        <td><app-tag-status [status]="transferencia.status"></app-tag-status></td>
        <td>{{ transferencia.numeroDocumentoErp }}</td>        
        <td>{{ transferencia.dataIntegracaoErp | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <app-tag-status [status]="transferencia.fgStatusInteg"></app-tag-status>
        </td>
        <td  class="nowrap">{{ transferencia.mensagem }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <td colspan="16">Nenhum registro encontrado</td>
    </ng-template>
  </p-table>
</div>
